import { queryOptions, useQuery } from '@tanstack/react-query';

import { DboCloudIntegrationSummaryResponse } from '@cast/types-database-optimizer';
import { QueryOptions } from '@cast/shared-types';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const apiFn = apiClient.dbo.getCloudIntegrationSummary;

const DBO_CLOUD_INTEGRATION_SUMMARY_QUERY_KEY = 'dbo-cloud-integration-summary';

const getCloudIntegrationSummaryQueryKey = (
  params: Partial<Parameters<typeof apiFn>[0]>
) => [DBO_CLOUD_INTEGRATION_SUMMARY_QUERY_KEY, params] as const;

export const useCloudIntegrationSummaryQuery = (
  params: Partial<Parameters<typeof apiFn>[0]>,
  options?: QueryOptions<DboCloudIntegrationSummaryResponse>
) => {
  const { ...ids } = params;

  return useQuery(
    queryOptions({
      queryKey: getCloudIntegrationSummaryQueryKey(ids),
      queryFn: async () => {
        const { data } = await apiFn({
          organizationId: ids.organizationId!,
          cloudIntegrationId: ids.cloudIntegrationId!,
        });
        return data;
      },
      enabled: makeIsEnabled(
        !!ids.organizationId && !!ids.cloudIntegrationId,
        options?.enabled
      ),
      ...options,
    })
  );
};
